const url = "/providencias";
const id = "idenProvidencia";

export const initFormProvidencia = {
    idenProvidencia: null,
    dataProvidencia: '',
    descProvidencia: '',
    dataSuperacao: '',
    flagSuperacao: "N",
    restricao : null,
    statProvidencia:   1
}

export function salvar(parm) {
    return new Promise(async (resolve, reject) => {
        if (parm[id] && parm[id] !== 0) {
        await atualizar(parm).then((res) => {
            resolve(res);
        });
        } else {
        await criar(parm).then((res) => {
            resolve(res);
        });
        }
    });
}

export function atualizar(parm) {
    return new Promise((resolve, reject) => {
        window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
        resolve(res.data);
        });
    });
}
  
export function criar(parm) {
    return new Promise((resolve, reject) => {
        window.$http.post(`${url}/${parm.restricao.idenRestricao}`, JSON.stringify(parm)).then((res) => {
            resolve(res.data);
        });
    });
}

export function excluir(idenProvidencia) {
    return new Promise((resolve, reject) => {
        window.$http.delete(`${url}/${idenProvidencia}`).then((res) => {
            resolve(res);
        });
    });
}

